import { Pipe, PipeTransform } from "@angular/core";
import { AppTransactionType } from "../enums/appTransactionType";

@Pipe({
  name: "transactionType",
})
export class TransactionTypePipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    if (value == undefined) {
      return "None";
    }
    switch (value as AppTransactionType) {
      case AppTransactionType.Withdraw:
        return "Withdraw";
      case AppTransactionType.Deposit:
        return "Deposit";
    }
  }
}
